import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoSizeInputDirective } from '@df/ui/form/auto-size-input.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { QtySelectComponentDecoratorDef } from '../../ui/form/qty-select/qty-select.component.decorator';

@Component({
    selector: 'basket-item-qty',
    templateUrl: 'basket-item-qty.html',
    styleUrls: ['basket-item-qty.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, AutoSizeInputDirective, FormsModule, TranslationModule]
})
export class BasketItemQtyComponent extends QtySelectComponentDecoratorDef {}
